export default __webpack_public_path__ + "static/media/cpp.9002a804.png";